import Card from "../Card/Card";
import CardFooter from "../CardFooter/CardFooter";
import styles from "./ContactCard.module.scss";

function ContactCard() {
  return (
    <Card className={styles.card} url={"mailto:d0000k1@yandex.ru"}>
      <div className={styles.subheadline}>Is there any suggestion?</div>
      <div className={styles.headline}>Click and you can contact me!</div>
      <CardFooter type="contact" />
    </Card>
  );
}

export default ContactCard;
